import React, { useState, useEffect, useCallback } from 'react';

const C = {
  primary: '#0F6E56', primaryBg: '#E1F5EE', border: '#E3E1D9',
  text: '#1F1E1B', muted: '#5F5E5A', gold: '#91600C', danger: '#C0392B',
};

const API = '/api/freelance';

function authHeaders() {
  const t = localStorage.getItem('token') || '';
  return { 'Content-Type': 'application/json', ...(t ? { Authorization: `Token ${t}` } : {}) };
}

function left(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  const h = Math.floor(Math.abs(ms) / 3600000);
  const d = Math.floor(h / 24);
  const txt = d > 0 ? `${d}d ${h % 24}h` : `${h}h`;
  return { late: ms < 0, text: txt };
}

/**
 * Order ki deadline. Sirf 'paid' orders par nazar aati hai -
 * delivery ke baad us ka koi matlab nahi.
 */
export default function OrderDeadline({ orderId, status, onChanged }) {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    fetch(`${API}/orders/${orderId}/deadline/`, { headers: authHeaders() })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (j && !j.error) setD(j); })
      .catch(() => {});
  }, [orderId]);

  useEffect(() => { load(); }, [load]);

  if (!d || !d.due_at || status !== 'paid') return null;

  const t = left(d.due_at);
  if (!t) return null;

  const cancel = async () => {
    if (!window.confirm(
      `Cancel this order?\n\nThe work is ${d.hours_late} hours past its deadline.\n\n` +
      `You will get a full refund into your PenFlow wallet.`)) return;
    setBusy(true);
    try {
      const res = await fetch(`${API}/orders/${orderId}/cancel-late/`, {
        method: 'POST', headers: authHeaders(),
      });
      const j = await res.json();
      if (!res.ok) throw new Error(j.error || 'Could not cancel.');
      alert(`Cancelled. ${j.refunded_pi} Pi refunded to your wallet.`);
      if (onChanged) onChanged();
    } catch (e) { alert(e.message); }
    setBusy(false);
  };

  return (
    <div style={{
      marginTop: 6, padding: '5px 9px', borderRadius: 7,
      background: t.late ? '#FDEDEC' : C.primaryBg,
      border: `1px solid ${t.late ? C.danger : C.border}`,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span style={{ fontSize: 11.5, fontWeight: t.late ? 700 : 500, color: t.late ? C.danger : C.text }}>
          {t.late
            ? `\u23F0 LATE by ${t.text}`
            : `\u23F1\uFE0F Due in ${t.text}`}
        </span>
        {t.late && d.hours_until_cancel > 0 && (
          <span style={{ fontSize: 10, color: C.muted }}>
            cancellable in {d.hours_until_cancel}h
          </span>
        )}
      </div>

      {d.can_cancel && (
        <button
          onClick={cancel}
          disabled={busy}
          style={{
            marginTop: 5, fontSize: 11, fontWeight: 700, padding: '5px 11px',
            border: `1px solid ${C.danger}`, borderRadius: 6,
            background: '#fff', color: C.danger, cursor: busy ? 'wait' : 'pointer',
          }}
        >
          {busy ? '…' : 'Cancel & get a full refund'}
        </button>
      )}
    </div>
  );
}
